// extracted by mini-css-extract-plugin
module.exports = {"dropdown_container":"dropdown_container--ResourcesContainer-Resources-routes__2tZIE","dropdownContainer":"dropdown_container--ResourcesContainer-Resources-routes__2tZIE"};